<ion-button *ngIf="!simple"
            class="full-footer-button selection-option"
            [class.small]="small"
            [style.--background]="color"
            [style.--color]="contrastColor"
            [style.--background-hover]="altColor">
    <div>
        <span *ngIf="!!title" class="title">{{ title }}</span>
        <span [class.value]="!small && !simple">
            {{ value }}
        </span>
    </div>
</ion-button>

<ion-button *ngIf="simple"
            class="simple"
            [style.--background]="color"
            [style.--color]="contrastColor"
            [style.--background-hover]="altColor">
    <div>
        <span *ngIf="!!title" class="title">{{ title }}</span>
        <span [class.value]="!small && !simple">
            {{ value }}
        </span>
    </div>
</ion-button>
